var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$permissions['content-only'] && '-permission-content-only',attrs:{"id":"app"}},[_c('icons'),_vm._v(" "),_c('router-view',{attrs:{"loading":_vm.appGlobalLoading,"error":_vm.appGlobalError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }